import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { CrewInformationUb } from "../gql/graphql";
import { useCrewsQuery } from "../crew/useCrewsQuery";
import { RoutePaths } from "../RoutePaths";
import { useEffect, useState } from "react";
import { CyApp } from "../CyApp";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";

interface Props {
  currentCrewIdentifier: string | undefined;
}

export function CrewAwareItemsLink({ currentCrewIdentifier }: Props) {
  const { t } = useTranslation();

  const { crews } = useCrewsQuery();
  const [currentCrewMaybe, setCurrentCrewMaybe] = useState<
    CrewInformationUb | undefined
  >(undefined);

  useEffect(() => {
    const currentCrew = crews?.find(
      (c) => c.identifier === currentCrewIdentifier,
    );
    setCurrentCrewMaybe(currentCrew);
  }, [crews, currentCrewIdentifier]);

  return (
    <>
      {currentCrewMaybe && (
        <>
          <Button
            color="primary"
            className="me-2"
            data-cy={CyApp.ManageSongsheetsButton}
            to={RoutePaths.toItems(currentCrewMaybe.bucket)}
            tag={Link}
          >
            <FontAwesomeIcon icon={faPencil} className="pe-2" />
            {t("menu.manageSongsheets")}
          </Button>
        </>
      )}
    </>
  );
}
